export default "__VITE_ASSET__DTGXCi8X__"